import { triggerFilter } from './filterable.js'

function getItemCount() {
    const counts = {};
    document.querySelectorAll('div[class*="status-"]').forEach(el => {
        const statusClass = Array.from(el.classList).find(cls => cls.startsWith('status-'))
        if (statusClass) {
            const key = statusClass.replace('status-', '')
            counts[key] = (counts[key] || 0) + 1
        }
    })
    return counts
}

export function initFilter(inputId) {
    const input = document.getElementById(inputId)
    const filtersDiv = document.querySelector('div.filters')
    if (!filtersDiv) return

    const params = new URLSearchParams(window.location.search);
    const search = params.get('search')

    const counters = getItemCount()
    filtersDiv.innerHTML = ''
    for (const [key, count] of Object.entries(counters)) {
        const filterLink = document.createElement('a');
        filterLink.href = '#'
        filterLink.className = `filter-link status-${key}`
        if (search && key == search) {
            filterLink.classList.add('active')
        }
        filterLink.dataset.filter = key
        filterLink.textContent = `${key.charAt(0).toUpperCase() + key.slice(1)} (${count})`
        filterLink.addEventListener('click', (e) => {
            e.preventDefault()
            input.value = `status-${key}`
            triggerFilter(inputId)

            document.querySelectorAll('.filter-link').forEach(link => {
                link.classList.remove('active')
            })
            e.target.classList.add('active')
        });
        filtersDiv.appendChild(filterLink);
    }
}
